var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFomoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fomo-icon_svg__clip0_12493_82500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.142 30s6.358.75 6.358-3c0-6.023-9.845 2.087-13.5-9 9 3 7.5-3 15-3a9 9 0 010 18s-6 0-7.858-3z",
    fill: "#ADC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 39c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
    fill: "#597EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.998 16.515A14.931 14.931 0 0018 24c0 2.726.727 5.282 1.998 7.485A8.992 8.992 0 0024 24a8.992 8.992 0 00-4.002-7.485z",
    fill: "#1D39C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 36c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z",
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.249 29.336A8.96 8.96 0 0024 24a8.96 8.96 0 00-1.751-5.336A11.95 11.95 0 0021 24c0 1.917.45 3.728 1.249 5.336zM34.5 22.5V15h-3v10.5H39v-3h-4.5z",
    fill: "#597EF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fomo-icon_svg__clip0_12493_82500"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/fomo-icon.7a6151ab2e12c36e8a16c3fccc9e8c8c.svg";
export { SvgFomoIcon as ReactComponent };